import { ErrorOutline } from "@mui/icons-material";
import { Skeleton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useRef } from "react";
import { useRateAgreementById } from "./hooks/useRateAgreementById";

const useStyles = makeStyles({
  "@keyframes fadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  fadeIn: {
    animation: "$fadeIn 1s ease-in"
  }
});

interface RateAgreementNameProps {
  agreementId: string;
}

export default function RateAgreementName({
  agreementId
}: RateAgreementNameProps) {
  const classes = useStyles();
  const { rateAgreement, loading, error } = useRateAgreementById(agreementId);
  // Track whether data was absent on first render — only animate async fetches.
  const wasLoadingOnMount = useRef(rateAgreement == null);
  if (error) return <ErrorOutline color="secondary" />;
  if (loading) return <Skeleton variant="text" width={100} />;
  return (
    <div
      data-testid="rate-agreement-nav"
      className={wasLoadingOnMount.current ? classes.fadeIn : undefined}
    >
      {rateAgreement?.name ?? agreementId}
    </div>
  );
}
